export default "__VITE_ASSET__s8l8$wgV__"